"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = require("react");
var InvoiceDetails_1 = __importDefault(require("containersRechargly/Recharges/Invoices/InvoiceDetails"));
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var CompressedInvoicePreviewHeader_1 = __importDefault(require("./CompressedInvoicePreviewHeader"));
var InvoicePreviewHeader_1 = __importDefault(require("./InvoicePreviewHeader"));
var tableConf_1 = require("./tableConf");
var Invoice = function (_a) {
    var invoice = _a.invoice, showTextOnExpand = _a.showTextOnExpand;
    var theme = (0, material_1.useTheme)();
    var isMobileScreen = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    var hasDiscount = invoice.lineItems.some(function (lI) { return lI.discount && lI.discount > 0; });
    var tableConf = (0, react_1.useMemo)(function () { return isMobileScreen ? tableConf_1.mobileSizeInvoiceDetailsTableConf : (0, tableConf_1.getCompressedInvoiceDetailsTableConf)(hasDiscount); }, [hasDiscount]);
    var invNum = (0, end2end_1.getInvoiceCode)(invoice);
    var accordionId = "INV-".concat(invNum);
    var isInvSelected = window.location.hash === "#".concat(accordionId);
    (0, react_1.useEffect)(function () {
        if (isInvSelected) {
            setTimeout(function () { var _a; return (_a = document.getElementById(accordionId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 200);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Accordion_1.default, __assign({ id: "INV-".concat(invNum), hideBorders: true, offsetHor: true, defaultExpanded: isInvSelected }, { children: [isMobileScreen
                ? (0, jsx_runtime_1.jsx)(CompressedInvoicePreviewHeader_1.default, { item: invoice })
                : (0, jsx_runtime_1.jsx)(InvoicePreviewHeader_1.default, { item: invoice, showTextOnExpand: showTextOnExpand }), (0, jsx_runtime_1.jsx)(InvoiceDetails_1.default, { item: invoice, tableConf: tableConf, tableSize: "compact", placement: "clientAgreement" })] })));
};
exports.default = Invoice;
